import { Controller } from 'stimulus';

class Country extends Controller {
  connect() {
    this.writeRegex();
  }

  onChange() {
    this.writeRegex();
  }

  selectedOption() {
    return this.element.options[this.element.selectedIndex];
  }

  findPostalField() {
    const fieldset = this.element.closest('fieldset');

    if (!fieldset) {
      return null;
    }

    return fieldset.querySelector('[name*="postal_code"]');
  }

  writeRegex() {
    const regex = this.selectedOption().getAttribute('data-postal-regex');
    const postalField = this.findPostalField();

    if (postalField && regex) {
      postalField.setAttribute('pattern', regex);
    }
  }
}

Country.targets = [
  //
];

export default Country;
